import { useTranslation } from "react-i18next";
import styled from "styled-components";
import type { GetChargesByRelatedDriverResponse } from "@qivia/schemas-ev-charging";
import {
  dateFormatterHourMinute,
  formatAmount,
  IconCircle,
  ListRow,
  TextCapitalized,
} from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { BoltOutlined } from "@qivia/ui/src/designSystem/materialUi/materialUi";

export interface HomeChargeRowProps {
  charge: GetChargesByRelatedDriverResponse[number];
}

export const HomeChargeRow = ({ charge }: HomeChargeRowProps) => {
  const { t } = useTranslation();

  return (
    <ListRow
      leftIcon={<IconCircle icon={<BoltOutlined />} />}
      title={t("appV2.refunds.homeCharge", {
        energy: charge.totalEnergy ?? "-",
      })}
      subtitle={`${charge.startAt ? dateFormatterHourMinute(new Date(charge.startAt)) : "-"} → ${charge.stopAt ? dateFormatterHourMinute(new Date(charge.stopAt)) : "-"}`}
      rightElement={
        <StyledAmount>
          {charge.excludedAt ? (
            <TextCapitalized>{t("appV2.refunds.excluded")}</TextCapitalized>
          ) : charge.reimbursementAmount === null ? (
            "-"
          ) : (
            `+ ${formatAmount(charge.reimbursementAmount)} €`
          )}
        </StyledAmount>
      }
    />
  );
};

const StyledAmount = styled.span`
  ${typographies["Body/XL"]}
  color: ${colors["colors/text/black"]};
`;
